import { useState } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";

import TopNav from "@/components/TopNav";
import Hero from "@/components/Hero";
import CreativeCampaigns from "@/components/CreativeCampaigns";
import Methodology from "@/components/Methodology";
import BrandedBento from "@/components/BrandedBento";
import BigSharks from "@/components/BigSharks";
import SocialGrid from "@/components/SocialGrid";
import CaseStudies from "@/components/CaseStudies";
import MarqueeCredits from "@/components/MarqueeCredits";
import CTAViewfinder from "@/components/CTAViewfinder";
import Footer from "@/components/Footer";
import CameraHUD from "@/components/CameraHUD";
import VideoModal from "@/components/VideoModal";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const [active, setActive] = useState(null);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, anchors: true }}>
      <div className="relative min-h-screen bg-[#0a0a0b] font-body text-[#ECEAE3]">
        <div className="vignette-layer" />
        <CameraHUD />
        <TopNav />
        <main className="relative z-10">
          <Hero />
          <CreativeCampaigns />
          <Methodology />
          <BrandedBento onOpen={setActive} />
          <BigSharks onOpen={setActive} />
          <SocialGrid onOpen={setActive} />
          <CaseStudies />
          <MarqueeCredits />
          <CTAViewfinder />
          <Footer />
        </main>
        <VideoModal active={active} onClose={() => setActive(null)} />
        <Toaster position="bottom-center" />
      </div>
    </ReactLenis>
  );
}

export default App;
